export default __webpack_public_path__ + "static/sparklepay-logs-365e9e2a94f00e3a394af938aba4e09a.svg";